export enum EUserType {
    Company,
    Worker
}

export enum ESettori {
    Ortofrutta,
    Florovivaismo,
    ViteOlivo,
    Allevamento
}

export enum EFalseTrue {
    false = 'No',
    true = 'Sì',
    undefined = 'Non specificato'
}

export enum ESettoreDescription {
    'Ortofrutta',
    'Florovivaismo',
    'Vite e Olivo',
    'Allevamento'
}

export interface IPoint {
    lat: number
    lng: number
}

export interface IPieGenerator{
    amount:number
    dataSettore?:number
}

export interface IPiePath{
    d:string
    transform: string
    dataSettore?:number
}

export interface IPartners {
    logo_src:string
    nome:string
}
